import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const TvStatus = (param)=>{
    let { icon , color ="white" , text , className  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("px-4 py-2 rounded-full flex items-center gap-2 text-xs font-medium w-fit", tvStatusBgColor(color), tvStatusTextColor(color), className),
        children: [
            icon ? icon : /*#__PURE__*/ _jsxs("div", {
                className: "relative w-[8px] h-[8px]",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute w-full h-full rounded-full bg-white p-[2px] border border-2 border-red-600 drop-shadow-[0_0_4px_#DC2626] animate-ping opacity-40"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-red-600 w-2 h-2 rounded-full"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                children: text || "On now"
            })
        ]
    });
};
function tvStatusBgColor(color) {
    switch(color){
        case "red":
            return "bg-red-600";
        default:
            return "bg-white";
    }
}
function tvStatusTextColor(color) {
    switch(color){
        case "red":
            return "text-white";
        default:
            return "text-black";
    }
}
